/* 产品规格选择 */
<template>
  <div>
    <z-dialog :title="title" v-model="display" @close="closeDialog" @submit="submit">
      <div :class="preflxCls">
        <Row
          :class="preflxCls+'-item'"
          v-for="(item, index) in choicedSpec"
          :key="index"
          :gutter="30"
          type="flex"
          justify="center"
          align="middle"
        >
          <Col span="5">
            <z-panelimg
              :del="false"
              width="108"
              height="108"
              :src="item.specFile ? ossUrl + item.specFile.key : ''"
            ></z-panelimg>
          </Col>

          <Col span="15" class="text">
            <div>
              <p class="title">{{item.color}}</p>
              <p class="size">{{item.size}}</p>
              <p class="spec">{{item.material}}</p>
            </div>
          </Col>
          <Col span="4" class="text">
            <Tag v-if="!item.visible">已下架</Tag>

            <Radio v-else @on-change="chioceSpec(item, index)" size="large" v-model="item.choiced"></Radio>
          </Col>
        </Row>
      </div>
    </z-dialog>
  </div>
</template>
<script>
const preflxCls = "zSpeclog";
import { findComponentDownward } from "../../utils/assist.js";
import ZPanelimg from "../panelimg/panelimg";
export default {
  name: "ZSpeclog",
  provide() {
    return {
      app: this
    };
  },
  data() {
    return {
      preflxCls: preflxCls,
      diaologDom: null,
      single: false
    };
  },
  components: { ZPanelimg },
  props: {
    choicedSpec: {
      type: Array,
      default: function() {
        return [];
      }
    },
    ossUrl: {
      type: String,
      default: ""
    },
    display: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: "暂无标题"
    },
    width: {
      type: [Number, String],
      default: 360
    },
    // button text
    btnTxt: {
      type: [Number, String],
      default: "确定"
    },
    // 是否是长按钮
    long: {
      type: Boolean,
      default: false
    },
    // 是否需要取消
    cel: {
      type: Boolean,
      default: false
    },
    className: {
      type: String,
      default: "zhulogicModule"
    }
  },
  mounted() {
    const Dialog = findComponentDownward(this, "ZDialog");
    if (Dialog) {
      this.diaologDom = Dialog;
    }
  },
  watch: {
    display: function() {
      if (this.display) {
        this.diaologDom.op();
      } else {
        this.diaologDom.close();
      }
    }
  },
  methods: {
    closeDialog() {
      this.$emit("close");
    },
    submit() {
      const newObj =
        this.choicedSpec && this.choicedSpec.filter(item => item.choiced)[0];
      if (!newObj) {
        this.$Message.warning("至少选择一个规格！");
        return false;
      }
      this.$emit("submitHandle", newObj);
    },
    chioceSpec(item, index) {
      this.choicedSpec.forEach(item => {
        this.$set(item, "choiced", false);
      });
      this.$set(this.choicedSpec[index], "choiced", true);
    }
  }
};
</script>
